import { LiftType } from "../generated/archive/lift-type";
import { OrgType } from "../generated/archive/org-type";
import { OrgStatus } from "../generated/archive/org-status";
import { ChannelType } from "../generated/archive/channel-type";
import { AdapterType } from "../generated/archive/adapter-type";
import { AdapterProtocol } from "../generated/archive/adapter-protocol";
import { UserStatus } from "../generated/archive/user-status";
import { NotificationType } from "../generated/archive/notification-type";
import { DeviceHierarchy } from "../generated/api/device-hierarchy";
import { IconType } from "../generated/api/icon-type";
import { RegisterType } from "../generated/api/register-type";

const liftTypeMap: Record<LiftType, string> = {
  [LiftType.ELEVATOR]: "ELEVATOR",
  [LiftType.ESCALATOR]: "ESCALATOR",
  [LiftType.MOVINGWALK]: "MOVINGWALK",
  [LiftType.BOT]: "BOT",
  [LiftType.GPIO]: "GPIO",
};

const orgTypeMap: Record<OrgType, string> = {
  [OrgType.MASTER]: "MASTER",
  [OrgType.ORG]: "ORG",
  [OrgType.SUBORG]: "SUBORG",
};

const orgStatusMap: Record<OrgStatus, string> = {
  [OrgStatus.DRAFT]: "DRAFT",
  [OrgStatus.ACTIVE]: "ACTIVE",
};

const channelTypeMap: Record<ChannelType, string> = {
  [ChannelType.SERIAL]: "SERIAL",
  [ChannelType.TCP]: "TCP",
  [ChannelType.UDP]: "UDP",
  [ChannelType.ADAPTER]: "ADAPTER",
  [ChannelType.TCP_BOT]: "TCP_BOT",
  [ChannelType.HTTP]: "HTTP",
};

const adapterTypeMap: Record<AdapterType, string> = {
  [AdapterType.REST]: "REST",
  [AdapterType.GRAPHQL]: "GRAPHQL",
  [AdapterType.GRPC]: "GRPC",
  [AdapterType.SOAP]: "SOAP",
  [AdapterType.WEBSOCKET]: "WEBSOCKET",
  [AdapterType.TCP]: "TCP",
};

const adapterProtocolMap: Record<AdapterProtocol, string> = {
  [AdapterProtocol.MCE]: "MCE",
  [AdapterProtocol.MODBUS]: "MODBUS",
  [AdapterProtocol.BEAGLE]: "BEAGLE",
  [AdapterProtocol.LN1]: "LN1",
  [AdapterProtocol.LN2]: "LN2",
  [AdapterProtocol.DILIGENT]: "DILIGENT",
  [AdapterProtocol.BACNET]: "BACNET",
  [AdapterProtocol.RVU]: "RVU",
  [AdapterProtocol.OPC]: "OPC",
  [AdapterProtocol.SEQUENT]: "SEQUENT",
  [AdapterProtocol.NUMATOGPIO]: "NUMATOGPIO",
  [AdapterProtocol.NUMATORELAY]: "NUMATORELAY",
  [AdapterProtocol.STM32]: "STM32",
  [AdapterProtocol.CGA]: "CGA",
  [AdapterProtocol.LOBBYVISION]: "LOBBYVISION",
  [AdapterProtocol.CANELEVATOR]: "CANELEVATOR",
  [AdapterProtocol.OPCUA]: "OPC UA",
  [AdapterProtocol.LOBBYVISION2]: "LOBBYVISION2",
};

const userStatusMap: Record<UserStatus, string> = {
  [UserStatus.NEW]: "NEW",
  [UserStatus.ACTIVE]: "ACTIVE",
  [UserStatus.OFFLINE_CREATED]: "OFFLINE_CREATED",
  [UserStatus.OFFLINE_SYNCED]: "OFFLINE_SYNCED",
  [UserStatus.OFFLINE_ACTIVE]: "OFFLINE_ACTIVE",
  [UserStatus.BLOCKED]: "BLOCKED",
  [UserStatus.DELETED]: "DELETED",
};

const notificationTypeMap: Record<NotificationType, string> = {
  [NotificationType.SMS]: "SMS",
  [NotificationType.EMAIL]: "EMAIL",
  [NotificationType.WHATSAPP]: "WHATSAPP",
};

const deviceHierarchyMap: Record<DeviceHierarchy, string> = {
  [DeviceHierarchy.PRIMARY]: "PRIMARY",
  [DeviceHierarchy.SECONDARY]: "SECONDARY",
  [DeviceHierarchy.CONTROL]: "CONTROL",
};

const iconTypeMap: Record<IconType, string> = {
  [IconType.STATUS]: "STATUS",
  [IconType.ACTION]: "ACTION",
  [IconType.SINGLEDOOR]: "SINGLEDOOR",
  [IconType.DOUBLEDOOR]: "DOUBLEDOOR",
};

const registerTypeMap: Record<RegisterType, string> = {
  [RegisterType.UNDEFINED]: "UNDEFINED",
  [RegisterType.BIT]: "BIT",
  [RegisterType.VALUE]: "VALUE",
  [RegisterType.ANALOG]: "ANALOG",
};

function enumLabel<T extends number>(map: Record<T, string>, value: T): string {
  return map[value] ?? "UNKNOWN";
}

export function liftTypeLabel(value: LiftType): string {
  return enumLabel(liftTypeMap, value);
}

export function orgTypeLabel(value: OrgType): string {
  return enumLabel(orgTypeMap, value);
}

export function orgStatusLabel(value: OrgStatus): string {
  return enumLabel(orgStatusMap, value);
}

export function channelTypeLabel(value: ChannelType): string {
  return enumLabel(channelTypeMap, value);
}

export function adapterTypeLabel(value: AdapterType): string {
  return enumLabel(adapterTypeMap, value);
}

export function adapterProtocolLabel(value: AdapterProtocol): string {
  return enumLabel(adapterProtocolMap, value);
}

export function userStatusLabel(value: UserStatus): string {
  return enumLabel(userStatusMap, value);
}

export function notificationTypeLabel(value: NotificationType): string {
  return enumLabel(notificationTypeMap, value);
}

export function deviceHierarchyLabel(value: DeviceHierarchy): string {
  return enumLabel(deviceHierarchyMap, value);
}

export function iconTypeLabel(value: IconType): string {
  return enumLabel(iconTypeMap, value);
}

export function registerTypeLabel(value: RegisterType): string {
  return enumLabel(registerTypeMap, value);
}
